import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ModifFormPovrch from '../comp/ModifFormPovrch';

function EditPovrch () {
    let { povrchId } = useParams();
    console.log("povrchId "+povrchId)

    const povrchy = useSelector((state: any) => state.allPrvky.povrchy);
    let povrch_povrchId = povrchy.find((dopl: any) => (dopl.id===povrchId)) 
    console.log("displaying povrch")
    console.log(povrch_povrchId) 
    return(
        <Container>
            <ModifFormPovrch edit={true} povrch={povrch_povrchId}/>
        </Container>)
}
export default EditPovrch